/**
 * Report Summary Card Component
 *
 * Displays a single metric value with label.
 */

interface ReportSummaryCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
}

export default function ReportSummaryCard({
  label,
  value,
  subtitle,
  icon,
}: ReportSummaryCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div className="flex items-start gap-3">
        {icon && <div className="text-gray-400 mt-1">{icon}</div>}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-500 truncate">{label}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
}
